import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { ChangePasswordGuard } from './shared/guards/changePassword.guard';
import { ConfirmGuard } from './shared/guards/confirmRegister.guard';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full',
	},
	{
		canActivate: [ChangePasswordGuard],
		path: 'success',
		loadComponent: () =>
			import('./features/payment-completed/payment-completed.component').then(
				(mod) => mod.PaymentCompletedComponent
			),
		title: 'HomAI | Pagamento Completato'
	},
	{
		canActivate: [ChangePasswordGuard],
		path: 'home',
		loadComponent: () =>
			import('./features/home/home.component').then((mod) => mod.HomeComponent),
		title: 'HomAI | Home'
	},
	{
		canActivate: [ChangePasswordGuard],
		path: 'how-it-works',
		loadComponent: () =>
			import('./features/info-section/info-section.component').then(
				(mod) => mod.InfoSectionComponent
			),
		title: 'HomAI | Come funziona'
	},
	{
		canActivate: [ChangePasswordGuard],
		path: 'about-us',
		loadComponent: () =>
			import('./features/info-section/info-section.component').then(
				(mod) => mod.InfoSectionComponent
			),
		title: 'HomAI | Chi siamo'
	},
	{
		canActivate: [ChangePasswordGuard],
		path: 'pricing',
		loadComponent: () =>
			import('./features/info-section/info-section.component').then(
				(mod) => mod.InfoSectionComponent
			),
		title: 'HomAI | Prezzi'
	},
	{
		path: 'agent-virtual',
		canActivate: [authGuard, ChangePasswordGuard],
		loadComponent: () =>
			import('./features/assistant/assistant.component').then(
				(mod) => mod.AssistantComponent
			),
		title: 'HomAI | Agente virtuale'
	},
	{
		path: 'consultant-virtual',
		canActivate: [authGuard, ChangePasswordGuard],
		loadComponent: () =>
			import('./features/assistant/assistant.component').then(
				(mod) => mod.AssistantComponent
			),
		title: 'HomAI | Consulente virtuale'
	},
	{
		path: 'designer-virtual',
		canActivate: [authGuard, ChangePasswordGuard],
		loadComponent: () =>
			import('./features/assistant/assistant.component').then(
				(mod) => mod.AssistantComponent
			),
		title: 'HomAI | Designer virtuale'
	},
	{
		path: 'prova-ora',
		canActivate: [authGuard, ChangePasswordGuard],
		loadComponent: () =>
			import('./features/assistant/assistant.component').then(
				(mod) => mod.AssistantComponent
			),
		title: 'HomAI | Prova ora'
	},
	{
		path: 'login-register-change',
		canActivate: [authGuard],
		loadComponent: () =>
			import(
				'./auth/change-password-internal/change-password-internal.component'
			).then((mod) => mod.ChangePasswordInternalComponent),
		title: 'HomAI | Home'
	},
	{
		path: 'pacchetti-acquistati',
		canActivate: [authGuard, ChangePasswordGuard],
		loadComponent: () =>
			import(
				'./features/pacchetti-acquisiti/pacchetti-acquisiti.component'
			).then((mod) => mod.PacchettiAcquisitiComponent),
		title: 'HomAI | Home'
	},
	{
		canActivate: [ChangePasswordGuard],
		path: 'scopri-di-piu',
		loadComponent: () =>
			import(
				'./features/scopri-di-piu/scopri-di-piu.component'
			).then((mod) => mod.ScopriDiPiuComponent),
		title: 'HomAI | Home'
	},
	{
		path: '**',
		canActivate: [ConfirmGuard],
		loadComponent: () =>
			import('./features/not-found/not-found.component').then(
				(mod) => mod.NotFoundComponent
			),
		title: 'Not Found Page'
	},
];
